import { createApp } from 'vue'
import App from './App.vue'
import router from './routes/index'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

// 路由发生变化修改页面title
router.beforeEach((to, from, next) => {
    if(to.meta.title) {
        document.title = to.meta.title
    }
    next()
})

const app = createApp(App)
app.use(router)
app.use(ElementPlus)
app.mount('#app')
